import React from 'react'

import { CalendarIcon } from '@fourthwall/icons'

import { AnalyticsSelectTool } from '../AnalyticsSelectTool/AnalyticsSelectTool'
import type { DateRangeOption, DateRangeValue } from './AnalyticsDateRangeSelect.types'
import { DateRangeOptions } from './components/DateRangeOptions/DateRangeOptions'
import { getValueLabel } from './utils/getValueLabel'

type AnalyticsDateRangeSelectProps = {
  value: DateRangeValue
  options: DateRangeOption[]
  onSelect: (value: DateRangeValue) => void
}

export const AnalyticsDateRangeSelect = ({
  value,
  options,
  onSelect,
}: AnalyticsDateRangeSelectProps) => {
  const handleSelect = (value: DateRangeValue) => {
    onSelect(value)
  }

  return (
    <AnalyticsSelectTool
      label={getValueLabel(value)}
      icon={CalendarIcon}
      renderContent={({ close }) => (
        <DateRangeOptions value={value} options={options} onSelect={handleSelect} onClose={close} />
      )}
    />
  )
}
